
import PageStyle from '@/styles/components/job-live/_index.module.scss';
import Button from '@/components/button';
import { ButtonStyle, REDIRECT, useNavbarStatus, useRouter, useSWR, useEffect, clearSWRCache, Tooltip} from '@/imports-files/common/common';
// import fb from "public/icons/fbicon.png";
// import twitter from "public/icons/twittericon.png";
// import linkedin from "public/icons/linkedicon.png";

import Fb from 'public/icons/fbicon.png';
import Twi from 'public/icons/twittericon.png';
import Li from 'public/icons/linkedicon.png';
import ArrowLeft from 'public/icons/arrowleft.svg';
import Image from "next/image";
import {FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon, LinkedinShareButton, LinkedinIcon} from "react-share";
import Confetti from 'react-confetti';
import { selectSidebarOptionFromUrl } from '@/actions/common/sidebar-values';
import ConfettiGif from '/public/images/confetti/confetti.gif';
import {useState} from 'react';
import {JobLivePopupAction} from '@/actions/components/job-live-popup';
import Clipboard from 'public/icons/clipboard.svg';
import { FormModalStyle } from "@/imports-files/components/common-modal/common-modal";


export default function JobLivePopup(props)
{
  const router = props.router;
  const { navbarStatus, updateNavbarStatus }          =   useNavbarStatus();
  clearSWRCache(`JobLivePopup`);
  const [isLoading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  const [clipboardMessage, setClipBoardMessage]     =   useState('Copy To Clipboard');
  const jobLivePopup    = new JobLivePopupAction(setApiError, router);
  const url = jobLivePopup.jobViewUrl(props.client_slug, props.job_slug);
  const { data, error } = useSWR(`JobLivePopup`, () => { return (jobLivePopup.updateJobLivePopupStatus()) });

  useEffect(() => {
      if (data) {
          setLoading(false)
      }
  }, [data])


  return(
    <div className={`${FormModalStyle.ModalOverlay}`}>
      <div className={`${FormModalStyle.Modal}`}>
         <div className={`${FormModalStyle.Modal__Container}`}>
           <div className={`${FormModalStyle.Modal__Container__CloseSection}`}
            onClick={() => {
              router.push({
                pathname: REDIRECT.client.activities
              })
            }}>
            <ArrowLeft />
            <span className={`ml15`}>Back to Dashboard </span>
           </div>
            <div className={`${FormModalStyle.Modal__Container__ContentSection} ${FormModalStyle.Modal__Container__ContentSection__FlexCenter}`}>
              <h1 className={`${FormModalStyle.Modal__Container__ContentSection__Heading}`}> Your Job Is Live </h1>
              {<div className={PageStyle.JobLive__Url}>
                <a href={url} target="_blank">Link to your job</a>
                <Tooltip className='SimpleTooltip' content={clipboardMessage} background= {'#00325A'} radius={20} padding = {8} placement = "top" fontSize= "12px">
                  <div  className  =   {`CareerPageTooltip ${PageStyle.JobLive__copyBtn}`}
                       onClick    =   {()=> jobLivePopup.copyToClipboard(url, setClipBoardMessage)}>
                  <Clipboard className="clipboardsvg" />
                </div>
              </Tooltip>
            </div>}
          </div>
          <div className={`${FormModalStyle.Modal__Container__ButtonSection} ${FormModalStyle.Modal__Container__ButtonSection__FlexCenter} ${FormModalStyle.Modal__Container__ButtonSection__PositionRelative} mt10`}>
            <Button buttonstyle={`${ButtonStyle.primarybtn} ${PageStyle.mar} `} onClick={() => { props.setJobLivePopup(false)
               router.push({pathname: REDIRECT.client.jobs.index, query: {job_type: 'Active'}});
             }}>
              View All Jobs
            </Button>
          </div>
          <div className={`${FormModalStyle.Modal__Container__ContentSection} ${FormModalStyle.Modal__Container__ContentSection__FlexCenter}`}>
            <h3 className={FormModalStyle.Modal__Container__ContentSection__SubHeading}>Share your job on social media</h3>
             <div className={PageStyle.JobLive__socialmedia}>
                <ul className={PageStyle.JobLive__SocialMedia}>
                  <li>
                    <FacebookShareButton
                      url={url}
                      quote={props.job_title}
                      hashtag="#charlie_recruit"
                      >
                     <Image src={Fb} alt='Facebook'></Image>
                    </FacebookShareButton>
                  </li>
                  <li>
                    <TwitterShareButton
                      url={url}
                      title={props.job_title}
                      >
                    <Image src={Twi} alt='Twitter'></Image>
                    </TwitterShareButton>
                  </li>
                  <li>
                    <LinkedinShareButton
                      url={url}
                      title={props.job_title}
                      summary={''}
                      source={"Charlie Recruit"}
                      // className={classes.socialMediaButton}
                      >
                      <Image src={Li} alt='Linkedin'></Image>
                      </LinkedinShareButton>
                  </li>
                </ul>
              </div>
          </div>
         </div>
      </div>
    </div>
  );

}
